<input ref="input"
       :maxlength="maxLength"
       @focus="onFocus"
       @blur="onBlur"
       @keyup="onKeyup"
       @keydown="onKeydownTextfield"
       @keydown.enter="onEnter"
       @change="onChange"
       @paste="onPasteTextfield"
       @drop="onDropTextfield"
       @textInput="onTextInput" />
